// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nYWG","col":"styles_col__3ff08"};